/* eslint-disable complexity */
/* eslint-disable max-statements */
import React, { useCallback, useMemo, useState, useEffect } from "react";
// import styles from "./styles.css";
import PropTypes from "prop-types";
import { Button } from "@cars24/turbo-web/lib/button";
import RatingInput from "@cars24/turbo-web/lib/rating-input";
import LoginSignupV2 from "../login-signup-v2";
import { Text } from "@cars24/turbo-web/lib/text";
import { Input } from "@cars24/turbo-web/lib/input";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";
import styles from "./styles.css";
import { TextArea } from "@cars24/turbo-web/lib/text-field";
// import UploadFile from "./images/upload-file.svg";
import { yieldToMain } from "../../../utils/helpers/yield-to-main";
import FeedBackDoneIcon from "./images/feedback-done.svg";
import nameValidator from "../../../utils/validators/name-validator";
import Dropdown from "../../shared/dropdown";
import sortByKey from "../../../utils/helpers/sort-by-key";

const ReviewForm = ({
    isLoggedIn,
    secureToken,
    saveCustomerReviewConnect,
    name,
    cities = [],
    carMakeList = [],
    models = [],
    fetchModelsBasedOnMakeConnect = () => {}
}) => {
    const { tokens } = useTokens();
    const [rating, setRating] = useState(0);
    const [review, setReview] = useState("");
    const [isBtnLoading, setIsBtnLoading] = useState(false);
    const [userName, setUserName] = useState(name || "");
    const [isSuccess, setIsSuccess] = useState(false);
    const [headline, setHeadline] = useState("");
    const [selectedCity, setSelectedCity] = useState(null);
    const [selectedMake, setSelectedMake] = useState(null);
    const [selectedModel, setSelectedModel] = useState(null);

    const cityList = cities || [];
    const carModelList = (Array.isArray(models) ? models : (models && models.all)) || [];

    useEffect(() => {
        if (selectedMake) {
            fetchModelsBasedOnMakeConnect(selectedMake.value);
        } else {
            setSelectedModel(null);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedMake]);

    const getSelectOptions = (list, labelKey, valueKey) => {
        return sortByKey(list, "display_order").map(item => ({
            label: item[labelKey],
            value: item[valueKey]
        }));
    };

    const modelOptions = useMemo(() => {
        if (!selectedMake) return [];
        return getSelectOptions(carModelList, "model_display", "model_id");
    }, [carModelList, selectedMake]);

    const handleSubmit = useCallback(async() => {
        await yieldToMain();
        setIsBtnLoading(true);
        const payload = {
            "review_description": review,
            "review_rating": rating,
            "customer_name": userName,
            "title": headline,
            ...(selectedCity && { cr_city_id: selectedCity.value }),
            ...(selectedMake && { cr_make_id: selectedMake.value }),
            ...(selectedModel && { cr_model_id: selectedModel.value })
        };
        saveCustomerReviewConnect(payload, secureToken).then(() => {
            setIsSuccess(true);
            setIsBtnLoading(false);
        }).catch(() => {
            setIsBtnLoading(false);
        });
    }, [headline, rating, review, saveCustomerReviewConnect, secureToken, userName, selectedCity, selectedMake, selectedModel]);

    if (!isLoggedIn) {
        return (
            <LoginSignupV2
                isNative
                isVisible
            />
        );
    }

    if (isSuccess) {
        return (
            <div styleName={"styles.feedbackSubmit"}>
                <img src={FeedBackDoneIcon} alt="done icon" width="114px" height="116px" />
                <Text
                    align="center"
                    as="p"
                    fontWeight="semibold"
                    size="400"
                    transform="none"
                    color={tokens.text_default_text_primary}
                >
                    Thanks for your feedback!
                </Text>
                <Text
                    align="center"
                    as="p"
                    fontWeight="regular"
                    size="300"
                    transform="none"
                    color={tokens.text_default_text_secondary}
                >
                    Your feedback has been recorded and will help<br />shape better experiences for everyone.
                </Text>
            </div>
        );
    }

    const isSubmitDisabled =  !(rating && review && headline && userName && userName.trim() && nameValidator(userName) && selectedCity && selectedMake && selectedModel);

    return (
        <div styleName={"styles.reviewForm"}>
            <div styleName={"styles.heading"}>
                <Text
                    align="left"
                    as="p"
                    fontWeight="semibold"
                    size="450"
                    transform="none"
                    color={tokens.text_default_text_primary}
                >
                Reviews & Ratings
                </Text>
            </div>
            <div styleName={"styles.rattingWrapper"}>
                <div styleName={"styles.rattingCard"}>
                    <Text
                        align="left"
                        as="p"
                        fontWeight="medium"
                        size="350"
                        transform="none"
                        color={tokens.text_default_text_primary}
                    >
                    Overall rating
                        <Text
                            align="left"
                            as="span"
                            fontWeight="medium"
                            size="350"
                            transform="none"
                            color="#B4272E"
                        >*</Text>
                    </Text>

                    <RatingInput
                        onChange={(value) => setRating(value)}
                        size="large"
                        value={rating}
                        max={5}
                    />
                </div>

                <div styleName={"styles.rowTwoCols"}>
                    <div styleName={"styles.col"}>
                        <div styleName={"styles.rattingCard"}>
                            <Text
                                align="left"
                                as="p"
                                fontWeight="medium"
                                size="350"
                                transform="none"
                                color={tokens.text_default_text_primary}
                            >
                                Name
                                <Text
                                    align="left"
                                    as="span"
                                    fontWeight="medium"
                                    size="350"
                                    transform="none"
                                    color="#B4272E"
                                >*</Text>
                            </Text>
                            <Input
                                customErrorMessage=""
                                hint=""
                                onChange={(e) => setUserName(e.target.value)}
                                placeholder="Enter your name"
                                type="text"
                                validator={nameValidator}
                                value={userName}
                            />
                        </div>
                    </div>

                    <div styleName={"styles.col"}>
                        <div styleName={"styles.rattingCard"}>
                            <Text
                                align="left"
                                as="p"
                                fontWeight="medium"
                                size="350"
                                transform="none"
                                color={tokens.text_default_text_primary}
                            >
                                City
                                <Text
                                    align="left"
                                    as="span"
                                    fontWeight="medium"
                                    size="350"
                                    transform="none"
                                    color="#B4272E"
                                >*</Text>
                            </Text>
                            <Dropdown
                                options={getSelectOptions(cityList, "city_name", "city_id")}
                                value={selectedCity}
                                onChange={setSelectedCity}
                                placeholder="Select city"
                                isRevamped={true}
                            />
                        </div>
                    </div>
                </div>

                <div styleName={"styles.rowTwoCols"}>
                    <div styleName={"styles.col"}>
                        <div styleName={"styles.rattingCard"}>
                            <Text
                                align="left"
                                as="p"
                                fontWeight="medium"
                                size="350"
                                transform="none"
                                color={tokens.text_default_text_primary}
                            >
                                Car make
                                <Text
                                    align="left"
                                    as="span"
                                    fontWeight="medium"
                                    size="350"
                                    transform="none"
                                    color="#B4272E"
                                >*</Text>
                            </Text>
                            <Dropdown
                                options={getSelectOptions(carMakeList, "make_display", "make_id")}
                                value={selectedMake}
                                onChange={(option) => {
                                    const prevMakeValue = selectedMake && selectedMake.value;
                                    setSelectedMake(option);
                                    if (!option || option.value !== prevMakeValue) {
                                        setSelectedModel(null);
                                    }
                                }}
                                placeholder="Select make"
                                isRevamped={true}
                            />
                        </div>
                    </div>

                    <div styleName={"styles.col"}>
                        <div styleName={"styles.rattingCard"}>
                            <Text
                                align="left"
                                as="p"
                                fontWeight="medium"
                                size="350"
                                transform="none"
                                color={tokens.text_default_text_primary}
                            >
                                Car model
                                <Text
                                    align="left"
                                    as="span"
                                    fontWeight="medium"
                                    size="350"
                                    transform="none"
                                    color="#B4272E"
                                >*</Text>
                            </Text>
                            <Dropdown
                                options={modelOptions}
                                value={selectedModel}
                                onChange={setSelectedModel}
                                placeholder="Select model"
                                disabled={!selectedMake}
                                isRevamped={true}
                            />
                        </div>
                    </div>
                </div>

                <div styleName={"styles.rattingCard"}>
                    <Text
                        align="left"
                        as="p"
                        fontWeight="medium"
                        size="350"
                        transform="none"
                        color={tokens.text_default_text_primary}
                    >
                        Add headline
                        <Text
                            align="left"
                            as="span"
                            fontWeight="medium"
                            size="350"
                            transform="none"
                            color="#B4272E"
                        >*</Text>
                    </Text>
                    <Input
                        customErrorMessage=""
                        hint=""
                        onChange={(e) => setHeadline(e.target.value)}
                        placeholder="Add headline"
                        type="text"
                        validator={() => {}}
                        value={headline}
                    />
                </div>

                <div styleName={"styles.rattingCard"}>
                    <Text
                        align="left"
                        as="p"
                        fontWeight="medium"
                        size="350"
                        transform="none"
                        color={tokens.text_default_text_primary}
                    >
                        Add review
                        <Text
                            align="left"
                            as="span"
                            fontWeight="medium"
                            size="350"
                            transform="none"
                            color="#B4272E"
                        >*</Text>
                    </Text>
                    <TextArea
                        label=""
                        value={review}
                        charLength={2000}
                        onChange={(e) => setReview(e.target.value)}
                        placeholder="Add review"
                    />
                </div>

                {/* <div styleName={"styles.rattingCard"}>
                    <Text
                        align="left"
                        as="p"
                        fontWeight="medium"
                        size="350"
                        transform="none"
                        color={tokens.text_default_text_primary}
                    >
                        Add a photo
                    </Text>
                    <label styleName={"styles.uploadFile"}>
                        <input type="file" />
                        <img src={UploadFile} alt="upload" />
                    </label>
                </div>*/}
            </div>

            <div styleName={"styles.reviewSubmitForm"}>
                <Button
                    disabled={!(!isSubmitDisabled)}
                    variant="primary"
                    size="large"
                    type="button"
                    label={"Submit review"}
                    loading={isBtnLoading} onClick={handleSubmit} />
            </div>
        </div>
    );
};

ReviewForm.propTypes = {
    isLoggedIn: PropTypes.bool,
    secureToken: PropTypes.string,
    saveCustomerReviewConnect: PropTypes.func,
    name: PropTypes.string,
    cities: PropTypes.array,
    carMakeList: PropTypes.array,
    models: PropTypes.array,
    fetchModelsBasedOnMakeConnect: PropTypes.func
};

export default ReviewForm;
